export default theme => ({
    neutral: {
        '& .MuiBadge-badge': {
            backgroundColor: theme.palette.grey[200],
            color: theme.palette.text.primary,
            fontWeight: theme.typography.fontWeightRegular,
            position: 'static',
            transform: 'none',
            minWidth: theme.spacing(2.5),
            height: theme.spacing(2.5),
            padding: theme.spacing(0, 0.75),
            borderRadius: theme.spacing(2),
        },
    },
});
